import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileSignature, ShieldCheck, Wrench, KeyRound, Eye, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, dataIt } from "@/lib/api";
import { CondividiButton } from "@/components/CondividiButton";

const ICONS = { privacy: ShieldCheck, scheda: Wrench, contratto: KeyRound, preventivo: FileText };
const LINK = { privacy: (d) => `/clienti/${d.id}/privacy`, scheda: (d) => `/schede/${d.id}/stampa`, contratto: (d) => `/noleggi/${d.id}/contratto`, preventivo: (d) => `/preventivi/${d.id}/stampa` };

export const ArchivioDocumenti = ({ c, negozio, refreshKey }) => {
  const navigate = useNavigate();
  const [docs, setDocs] = useState(null);
  useEffect(() => {
    api.get(`/clienti/${c.id}/documenti`).then((r) => setDocs(r.data)).catch(() => setDocs([]));
  }, [c.id, refreshKey]);

  return (
    <section className="rounded-lg border border-slate-200 bg-white shadow-sm" data-testid="cliente-documenti-list">
      <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3">
        <FileSignature className="h-4 w-4 text-orange-600" />
        <h2 className="font-heading text-base font-bold">Documenti firmati ({docs?.length ?? 0})</h2>
      </div>
      <ul className="divide-y divide-slate-100">
        {(docs || []).map((d) => {
          const Icon = ICONS[d.tipo];
          const key = `${d.tipo}-${d.id}`;
          return (
            <li key={key} className="flex flex-wrap items-center justify-between gap-3 px-5 py-3 text-sm" data-testid={`documento-${key}`}>
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-slate-100 text-slate-600"><Icon className="h-4 w-4" /></span>
                <div>
                  <p className="font-semibold text-slate-900">{d.titolo} {d.numero && <span className="font-mono text-xs font-bold text-orange-600">{d.numero}</span>}</p>
                  <p className="text-xs text-slate-500" data-testid={`documento-data-${key}`}>
                    Firmato il {d.data ? dataIt(d.data.slice(0, 10)) : "—"} · {d.digitale ? "firma su schermo" : "firma su carta"}
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                <Button size="sm" variant="outline" onClick={() => navigate(LINK[d.tipo](d))} data-testid={`documento-apri-${key}`}><Eye className="mr-1 h-3.5 w-3.5" /> Apri</Button>
                <CondividiButton size="sm" tipo={d.tipo} id={d.id} telefono={c.telefono} nome={c.nome} numero={d.numero} firmato negozio={negozio}
                  label="Rinvia" testId={`documento-rinvia-${key}`} />
              </div>
            </li>
          );
        })}
        {docs && docs.length === 0 && <li className="px-5 py-8 text-center text-sm text-slate-500" data-testid="documenti-empty">Nessun documento firmato.</li>}
        {!docs && <li className="px-5 py-8 text-center text-sm text-slate-400">Caricamento...</li>}
      </ul>
    </section>
  );
};
